import { OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
var GeneralFieldsComponent = /** @class */ (function () {
    function GeneralFieldsComponent() {
        this.hasCustomRule = false;
        this.subscriptions = [];
    }
    GeneralFieldsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.bounty) {
            this.hasCustomRule = !!this.bounty.custom_goal;
            this.customRule = this.bounty.custom_goal;
            this.reward = this.bounty.reward / 100;
        }
        var controls = {
            hasCustomRule: new FormControl(this.hasCustomRule),
            customRule: new FormControl(this.customRule),
            reward: new FormControl(this.reward, [
                Validators.required,
                Validators.min(1),
                Validators.max(1000),
            ]),
            isPool: new FormControl(this.isPool),
        };
        Object.keys(controls).forEach(function (name) {
            if (!_this.parentForm.controls[name]) {
                _this.parentForm.addControl(name, controls[name]);
            }
        });
        // When beatmap goals change, update validators
        var beatmapGoalsSub = this.parentForm.controls.hasCustomRule.valueChanges.subscribe(function (value) {
            _this.setCustomRuleValidator(!!value);
        });
        this.subscriptions = [beatmapGoalsSub];
    };
    GeneralFieldsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    GeneralFieldsComponent.prototype.setCustomRuleValidator = function (isActive) {
        if (isActive) {
            this.parentForm.controls.customRule.setValidators([
                Validators.minLength(3),
                Validators.maxLength(74),
                Validators.required,
            ]);
        }
        else {
            this.parentForm.controls.customRule.clearValidators();
        }
        this.parentForm.controls.customRule.updateValueAndValidity();
    };
    GeneralFieldsComponent.prototype.hasError = function (controlKey) {
        var control = this.parentForm.get(controlKey);
        var touchedOrSubmitted = !control.pristine || this.submitFailed;
        return control.errors && touchedOrSubmitted;
    };
    Object.defineProperty(GeneralFieldsComponent.prototype, "canChangeReward", {
        get: function () {
            return !this.bounty || this.bounty.payment_type !== 'pool';
        },
        enumerable: true,
        configurable: true
    });
    return GeneralFieldsComponent;
}());
export { GeneralFieldsComponent };
